module.exports = __webpack_public_path__ + "static/media/wristwatch_1200.c9182206.jpg";